import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import AuthRequiredRoute from './shared/AuthRequiredRoute';
import AppLayout from './layout/AppLayout';

//app pages
import LoginPage from './login/LoginPage';
import ForgotPasswordPage from './login/ForgotPasswordPage';
import PasswordResetPage from './login/PasswordResetPage';
import TestsListPage from './testsList/TestsListPage';
import TestDetailsPage from './testDetails/TestDetailsPage';
import DynamicTestDetailsPage from './dynamicTestDetails/DynamicTestDetailsPage';
import MyProfilePage from './profile/MyProfilePage';
import AddUserPage from './profile/AddUserPage';
import EditUserPage from './profile/EditUserPage';
import SupportPage from './support/SupportPage';
import DashboardPage from './dashboard/DashboardPage';
import ReportManagementPage from './reportManagement/ReportManagementPage';
import MyCompanyPage from './companyDetails/MyCompanyPage';
import EditCompanyPage from './companyDetails/EditCompanyPage';
import AddCompanyPage from './companyDetails/AddCompanyPage';
import CompaniesListPage from './companiesList/CompaniesListPage';
import UsersListPage from './usersList/UsersListPage';
import CoverAndReportLayout from './reportLayout/CoverAndReportLayout';
import ReportOnlyLayout from './reportLayout/ReportOnlyLayout';
import QCReportLayout from './reportLayout/QCReportLayout';
import SummaryLayout from './reportLayout/SummaryLayout';
import EmailLayoutPage from './emailLayout/EmailLayoutPage';
import LayoutManagement from './LayoutManagement';
import CoverLetterLayout from './coverLetterLayout/CoverLetterLayout';
import ReportContentLayout from './reportContentLayout/ReportContentLayout';
import DefaultValues from './defaultValues';

class App extends React.Component {
  render() {
    const { isAuthenticated } = this.props;
    return (
      <AppLayout isAuthenticated={isAuthenticated}>
        <Switch>
          <Route exact path="/login" render={() => (isAuthenticated ? <Redirect to="/" /> : <LoginPage />)} />
          <Route
            exact
            path="/forgot-password"
            render={() => (isAuthenticated ? <Redirect to="/" /> : <ForgotPasswordPage />)}
          />
          <Route
            exact
            path="/account-recovery"
            render={({ location }) =>
              isAuthenticated ? <Redirect to="/" /> : <PasswordResetPage search={location.search} />
            }
          />
          <AuthRequiredRoute
            auth={isAuthenticated}
            exact
            path="/dashboard"
            component={(props) => <DashboardPage title="Dashboard" {...props} />}
          />
          <AuthRequiredRoute
            auth={isAuthenticated}
            exact
            path="/tests"
            component={(props) => <TestsListPage title="Manage Tests" {...props} />}
          />
          <AuthRequiredRoute auth={isAuthenticated} exact path="/tests/:id" component={TestDetailsPage} />
          <AuthRequiredRoute
            auth={isAuthenticated}
            exact
            path="/dynamictests/:id"
            component={(props) => <DynamicTestDetailsPage title="Manage Tests" {...props} />}
          />
          <AuthRequiredRoute
            auth={isAuthenticated}
            exact
            path="/help"
            component={(props) => <SupportPage title="Help/Support" {...props} />}
          />
          <AuthRequiredRoute auth={isAuthenticated} exact path="/companies" component={CompaniesListPage} />
          <AuthRequiredRoute
            auth={isAuthenticated}
            exact
            path="/mycompany"
            component={(props) => <MyCompanyPage title="My Company Info" {...props} />}
          />
          <AuthRequiredRoute
            auth={isAuthenticated}
            exact
            path="/companies/:id"
            component={(props) => <EditCompanyPage title="Edit Company" {...props} />}
          />
          <AuthRequiredRoute
            auth={isAuthenticated}
            exact
            path="/company"
            component={(props) => <AddCompanyPage title="Add Company" {...props} />}
          />
          <AuthRequiredRoute auth={isAuthenticated} exact path="/users" component={UsersListPage} />
          <AuthRequiredRoute
            auth={isAuthenticated}
            exact
            path="/profile"
            component={(props) => <MyProfilePage title="My Profile" {...props} />}
          />
          <AuthRequiredRoute
            auth={isAuthenticated}
            exact
            path="/users/:id"
            component={(props) => <EditUserPage title="Edit User" {...props} />}
          />
          <AuthRequiredRoute
            auth={isAuthenticated}
            exact
            path="/user"
            component={(props) => <AddUserPage title="Add User" {...props} />}
          />
          <AuthRequiredRoute auth={isAuthenticated} exact path="/reports" component={ReportManagementPage} />
          <AuthRequiredRoute
            auth={isAuthenticated}
            exact
            path="/reports/:companyId/coverLetter"
            component={CoverLetterLayout}
          />
          <AuthRequiredRoute
            auth={isAuthenticated}
            exact
            path="/reports/:companyId/reportContent"
            component={ReportContentLayout}
          />
          <AuthRequiredRoute auth={isAuthenticated} exact path="/layouts/" component={LayoutManagement} />
          <AuthRequiredRoute
            auth={isAuthenticated}
            exact
            path="/layouts/add"
            component={(props) => <LayoutManagement addLayout {...props} />}
          />
          <AuthRequiredRoute
            auth={isAuthenticated}
            exact
            path="/layouts/copy/:id"
            component={(props) => <LayoutManagement addLayout {...props} />}
          />
          <AuthRequiredRoute
            auth={isAuthenticated}
            exact
            path="/layouts/coverandreport/:type/:companyId"
            component={CoverAndReportLayout}
          />
          <AuthRequiredRoute
            auth={isAuthenticated}
            exact
            path="/layouts/reportonly/:type/:companyId"
            component={ReportOnlyLayout}
          />
          <AuthRequiredRoute
            auth={isAuthenticated}
            exact
            path="/layouts/qcreport/:type/:companyId"
            component={QCReportLayout}
          />
          <AuthRequiredRoute
            auth={isAuthenticated}
            exact
            path="/layouts/summaryreport/:type/:companyId"
            component={SummaryLayout}
          />
          <AuthRequiredRoute auth={isAuthenticated} exact path="/email" component={EmailLayoutPage} />
          <AuthRequiredRoute auth={isAuthenticated} exact path="/defaultValues/" component={DefaultValues} />
          <AuthRequiredRoute auth={isAuthenticated} component={() => <Redirect to="/dashboard" />} />
        </Switch>
      </AppLayout>
    );
  }
}

App.propTypes = {
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.auth,
});

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// src/components/App.jsx